import styled, { css } from 'styled-components';
import { BreakPoint } from 'styles/style-variables/breakpoint';

export const FaceIdCheckContainer = styled.div<{ $widgetWidth: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px 0;

  .sumsub-widget {

    iframe {
      display: flex;
      width: calc(480px - 48px);
    }
  }

  @media (max-width: ${BreakPoint.MobileTop}) {

    .sumsub-widget {

      iframe {
        ${({ $widgetWidth }) => css`
          width: calc(${$widgetWidth}px - 32px);
        `}
      }
    }
  }
`;
